import styles from './Relations.module.scss';

import React from 'react';

import { PrintBagProvider } from '@work4all/data/lib/hooks/useHandlePrint';

import { Panel } from '../../../../../components/panel/Panel';
import { UpdateEntity } from '../../../../../components/update-entity/UpdateEntity';
import { useMaskContext } from '../../../../../hooks/mask-context';
import { RelationsTable } from '../../../../contacts/components/tab-panels/pr/components/relations-section/RelationsTable';
import { BusinessPartners } from '../../../BusinessPartnerOverlayController';

export const RelationsTabPanel: React.FC = () => {
  const { data: entityData } = useMaskContext<BusinessPartners>();

  return (
    <Panel className={styles.panel}>
      {!entityData.id && <UpdateEntity />}
      {entityData?.id && (
        <PrintBagProvider>
          <RelationsTable enableURLState={false} />
        </PrintBagProvider>
      )}
    </Panel>
  );
};
